import { defineStore } from "pinia";
import ApiService from "@/services/ApiService";

export const useFavoriteGameStore = defineStore("favorite-games", () => {
  const state = reactive({
    favorite: [],
    error: null,
  });

  async function getFavorites() {
    try {
      const res = await ApiService.get("/api/favorite-game/favorite");
      if (res.data.success === true) {
        state.favorite = res.data.data;
      }
    } catch (error) {
      state.error = error;
      state.favorite = [];
    }
  }

  const favorites = computed(() => {
    return state.favorite.map(function (game) {
      game.image = game.image_cf || game.image

      return game
    });
  });

  const addFavorite = async function (game)  {
    try {
      await ApiService.post(`/api/favorite-game/favorite/${game.id}/add`)
        .then((res) => {
          if (res.data.success) {
            state.favorite.push(game);
          }
        })
        .catch((error) => {
          error.value = error;
        });
    } catch (error) {
      error.value = error;
    }
  }

  const removeFavorite = async function (game) {
    try {
      await ApiService.post(`/api/favorite-game/favorite/${game.id}/remove`)
        .then((res) => {
          if (res.data.success) {
            const index = state.favorite.findIndex((g) => g.id === game.id);
            if (index >= 0) {
              state.favorite.splice(index, 1);
            }
          }
        })
        .catch((error) => {
          error.value = error;
        }); 
    }
    catch (error) {
      error.value = error;
    }
  }

  async function clearFavorites() {
    state.favorite = [];
  }


  return {
    state,
    favorites,
    getFavorites,
    addFavorite,
    removeFavorite,
    clearFavorites,
  };
});

